/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckIn1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CheckIn from 'DesignSystem/CheckIn/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CheckIn1({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment/BottomAction/Content/CheckIn"
  
}) {
let eventAppointmentBooking0ValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.0',
})
let globalCurrentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location._id',
})
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
  return (<React.Fragment
>
<CheckIn
  viewPath={`${viewPath}/CheckIn`}
 data="event.appointment.booking.0"
 appointmentBooking={eventAppointmentBooking0ValueData}
 data="global.current_location._id"
 locationId={globalCurrentLocationIdValueData}
 data="patient._id"
 patientId={patientIdValueData}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 marginRight={8}
 size="small"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 marginLeft={4}
 text="Check in"
/>
)}
</TysiaButton>
)}
</CheckIn>
{children}
</React.Fragment>)
}